import IndexLayout from '../layouts';
import CandleChartModule from '../modules/candleCharts';
import ChartModule from '../modules/charts';

const appRoutes = [
  {
    path: '/',
    element: <IndexLayout />,
    children: [
      {
        path: 'charts',
        element: <ChartModule />,
      },
      {
        path: '/simple-charts/charts',
        element: <ChartModule />,
      },
      {
        path: 'candle_charts',
        element: <CandleChartModule />,
      },
    ],
  },
];

export default appRoutes;
